(function () {
  const DESKTOP_MQ = '(min-width: 990px)';
  /** How long the second image stays visible after the finger lifts (touch). */
  const TOUCH_HOLD_AFTER_LIFT_MS = 1000;

  function isDesktopLayout() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  let touchClearTimeoutId = null;

  function cancelScheduledTouchClear() {
    if (touchClearTimeoutId !== null) {
      clearTimeout(touchClearTimeoutId);
      touchClearTimeoutId = null;
    }
  }

  function scheduleTouchClear() {
    cancelScheduledTouchClear();
    touchClearTimeoutId = setTimeout(() => {
      touchClearTimeoutId = null;
      clearAllSecondary();
    }, TOUCH_HOLD_AFTER_LIFT_MS);
  }

  function clearAllSecondary() {
    cancelScheduledTouchClear();
    document.querySelectorAll('.product-card-wrapper .media.media--show-secondary').forEach((el) => {
      el.classList.remove('media--show-secondary');
    });
  }

  function showSecondary(media) {
    if (!media || isDesktopLayout()) return;
    cancelScheduledTouchClear();
    if (!media.classList.contains('media--hover-effect')) return;
    if (!media.querySelector('img + img')) return;
    document.querySelectorAll('.product-card-wrapper .media.media--show-secondary').forEach((m) => {
      if (m !== media) m.classList.remove('media--show-secondary');
    });
    media.classList.add('media--show-secondary');
  }

  function hideSecondary(media) {
    if (media) media.classList.remove('media--show-secondary');
  }

  function isPointOverMedia(clientX, clientY, media) {
    const r = media.getBoundingClientRect();
    return clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom;
  }

  /**
   * Title link ::after often stacks above the image on small screens, so events hit the <a> not .media.
   * Use coordinate checks against the real media box instead of listening only on .media.
   */
  function bindWrapper(wrapper) {
    if (wrapper.dataset.secondaryWrapperBound === '1') return;
    const media = wrapper.querySelector('.card__media .media.media--hover-effect');
    if (!media || !media.querySelector('img + img')) return;
    wrapper.dataset.secondaryWrapperBound = '1';

    wrapper.addEventListener(
      'pointermove',
      (e) => {
        if (isDesktopLayout()) return;
        if (e.pointerType === 'touch') return;
        if (isPointOverMedia(e.clientX, e.clientY, media)) showSecondary(media);
        else hideSecondary(media);
      },
      { passive: true }
    );

    wrapper.addEventListener(
      'pointerdown',
      (e) => {
        if (isDesktopLayout()) return;
        if (isPointOverMedia(e.clientX, e.clientY, media)) showSecondary(media);
      },
      { passive: true }
    );

    wrapper.addEventListener(
      'pointerleave',
      (e) => {
        if (isDesktopLayout()) return;
        if (e.pointerType === 'touch') {
          scheduleTouchClear();
        } else {
          hideSecondary(media);
        }
      },
      { passive: true }
    );
  }

  function bindAll() {
    document.querySelectorAll('.product-card-wrapper').forEach(bindWrapper);
  }

  if (!window.__productCardSecondaryMediaGlobals) {
    window.__productCardSecondaryMediaGlobals = true;
    document.addEventListener(
      'pointerup',
      (e) => {
        if (isDesktopLayout()) return;
        if (e.pointerType === 'touch') scheduleTouchClear();
      },
      { passive: true }
    );
    document.addEventListener(
      'pointercancel',
      (e) => {
        if (isDesktopLayout()) return;
        if (e.pointerType === 'touch') scheduleTouchClear();
      },
      { passive: true }
    );
  }

  const mql = window.matchMedia(DESKTOP_MQ);
  function onBreakpointChange(e) {
    if (e.matches) clearAllSecondary();
  }
  if (mql.addEventListener) {
    mql.addEventListener('change', onBreakpointChange);
  } else if (mql.addListener) {
    mql.addListener(onBreakpointChange);
  }

  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('facet:product-grid-updated', bindAll);
  document.addEventListener('product-cards:updated', bindAll);
})();
